import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { logoutAdmin } from '../utils/api';
import '../styles/layout.css';

const Layout = ({ children }) => {
  const admin = JSON.parse(localStorage.getItem('admin'));
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => window.innerWidth > 1024);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1024) {
        setIsSidebarOpen(true);
      } else {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (window.innerWidth <= 1024) {
      setIsSidebarOpen(false);
    }
  }, [location.pathname]);

  const handleLogout = () => {
    logoutAdmin();
  };

  const toggleSidebar = () => {
    setIsSidebarOpen((current) => !current);
  };

  const closeSidebar = () => {
    if (window.innerWidth <= 1024) {
      setIsSidebarOpen(false);
    }
  };

  return (
    <div className="layout">
      <button
        type="button"
        className="sidebar-toggle"
        onClick={toggleSidebar}
        aria-label={isSidebarOpen ? 'Close navigation menu' : 'Open navigation menu'}
        aria-expanded={isSidebarOpen}
      >
        <i className={`fas ${isSidebarOpen ? 'fa-xmark' : 'fa-bars'}`}></i>
      </button>

      {isSidebarOpen && <button type="button" className="sidebar-backdrop" onClick={closeSidebar} aria-label="Close sidebar"></button>}

      <aside className={`sidebar${isSidebarOpen ? ' sidebar-open' : ''}`}>
        <div className="sidebar-header">
          <h2><i className="fas fa-book"></i> School Portal</h2>
        </div>

        <nav className="sidebar-nav">
          <NavLink to="/dashboard" onClick={closeSidebar} className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
            <i className="fas fa-chart-bar"></i> Dashboard
          </NavLink>
          <NavLink to="/teachers" onClick={closeSidebar} className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
            <i className="fas fa-chalkboard-user"></i> Teachers
          </NavLink>
          <NavLink to="/students" onClick={closeSidebar} className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
            <i className="fas fa-graduation-cap"></i> Students
          </NavLink>
          <NavLink to="/fee-details" onClick={closeSidebar} className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
            <i className="fas fa-file-invoice-dollar"></i> Fee Details
          </NavLink>
          <NavLink to="/site-enquiries" onClick={closeSidebar} className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
            <i className="fas fa-envelope-open-text"></i> Site Enquiry
          </NavLink>
          {admin?.role === 'super_admin' && (
            <>
              <NavLink to="/admins" onClick={closeSidebar} className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
                <i className="fas fa-user-shield"></i> Admins
              </NavLink>
              <NavLink to="/classes" onClick={closeSidebar} className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
                <i className="fas fa-layer-group"></i> Manage Classes
              </NavLink>
              <NavLink to="/fee-categories" onClick={closeSidebar} className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
                <i className="fas fa-tags"></i> Fee Categories
              </NavLink>
              <NavLink to="/academic-sessions" onClick={closeSidebar} className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
                <i className="fas fa-calendar-days"></i> Academic Sessions
              </NavLink>
            </>
          )}
        </nav>

        <div className="sidebar-footer">
          <div className="admin-info">
            <p><i className="fas fa-user"></i> {admin?.name}</p>
            <small>{admin?.email}</small>
            <small className="admin-role">{admin?.role || 'admin'}</small>
          </div>
          <button className="btn btn-danger btn-block" onClick={handleLogout}>
            <i className="fas fa-right-from-bracket"></i> Logout
          </button>
        </div>
      </aside>

      <main className="main-content">
        <div className="container">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;
